.activeStateFilter {
    width: 270px;
    margin-left: auto;
    margin-bottom: 16px;
}